import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSelectChange } from '@angular/material';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgForm } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { ViewChild } from '@angular/core';
import { ReservaRecurrente, ReservaRecurrenteData } from '@app/_models/reserva';
import { ReservasService } from '@app/services/reservas.service';
import { SessionService } from '@app/services/session.service';

import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import 'moment/locale/es';
import { FieldCapacity } from '@app/_models/facilities';
import { ReservationsData } from '@app/_models/reservation-data';

const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-reserva-recurrente-modal',
  templateUrl: './reserva-recurrente-modal.component.html',
  styleUrls: ['./reserva-recurrente-modal.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
  ]
})

export class ReservaRecurrenteModalComponent implements OnInit {

  reserva: ReservaRecurrente;
  openShifts: any = ['18:00 - 19:00', '19:00 - 20:00', '20:00 - 21:00', '21:00 - 22:00', '22:00 - 23:00', '23:00 - 00:00'];
  fieldSizes: FieldCapacity[];
  days: string[] = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  f_date = new FormControl(moment());
  f_turno: string;
  minDate: Date;
  end_date_control = new FormControl(moment());
  selected_weekdays: number[] = [];
  minEndDate: Date;
  listAvailable: any[] = [];
  listUnavailable: any[] = [];
  changeStep: boolean = true;
  clickDouble: boolean = false;
  updateReserva: boolean = false;

  @ViewChild('f', { static: false }) form: NgForm;

  onAdd = new EventEmitter();
  startDate: Date;
  endDate: Date;

  constructor(
    public modalRef: MatDialogRef<ReservaRecurrenteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReservaRecurrenteData,
    private reservasService: ReservasService,
    private session: SessionService,
    private _snackBar: MatSnackBar
  ) {
    this.reserva = data.reserva
    this.f_date.setValue(moment(data.day))
    this.updateReserva = data.updateReserva;
  }

  ngOnInit() {
    if (this.f_date) {
      this.minDate = new Date();
      this.reserva.start_time = this.f_date.value;
      this.fieldSizes = this.session.field_sizes;
    }
    this.getSelectedWeekdays();
    this.selectTurno();
  }

  onNoClick(): void {
    this.modalRef.close();
  }

  onHourSelect() {
    if (this.f_date.value) {
      this.f_date.value.set({
        hour: parseInt(this.f_turno.slice(0, 2)),
        minute: parseInt(this.f_turno.slice(3, 5)),
        second: 0
      });
    }
  }

  getSelectedWeekdays() {
    if (this.reserva.reservation_group) {
      this.reservasService.getSelectedWeekdays(this.reserva.reservation_group)
        .subscribe(
          (data: WeekdayData) => {
            if (Array.isArray(data.weekday)) {
              this.selected_weekdays = data.weekday.filter((value, index, self) => {
                return self.indexOf(value) === index;
              });
            }
            this.startDate = data.start_date;
            this.endDate = data.end_date;
            
            this.f_date.setValue(this.startDate);
            this.end_date_control.setValue(this.endDate);
          },
          (error: any) => {
            console.error("Ocurrió un error al obtener los datos:", error);
          }
        );
    }
  }

  onSelectionChange(event: MatSelectChange) {
    this.selected_weekdays = event.value;
  }

  listAvailableFunc() {
    const sdate = new Date(this.f_date.value);
    const fDate = new Date(this.end_date_control.value);
    sdate.setHours(parseInt(this.f_turno.slice(0, 2)));
    sdate.setMinutes(parseInt(this.f_turno.slice(3, 5)));
    fDate.setHours(parseInt(this.f_turno.slice(0, 2)));
    fDate.setMinutes(parseInt(this.f_turno.slice(3, 5)));
    
    this.reserva.start_time = sdate;  
    this.reserva.end_date = fDate;
    this.reserva.facility = this.session.currentFacility.id;
    this.reserva.selected_weekdays = this.selected_weekdays;
    
    this.listAvailable = [];
    this.listUnavailable = [];

    this.reservasService.addRecurrenteList(this.reserva)
      .subscribe(
        (data: ReservationsData) => {

          this.listAvailable = this.listAvailable.concat(
            data.base_reservations_available,
            data.child_reservations_available
          );

          this.listUnavailable = this.listUnavailable.concat(
            data.base_reservations_unavailable,
            data.child_reservations_unavailable
          );

          this.clickDouble = this.listAvailable.length == 0 && this.listUnavailable.length > 0;
        },
        error => {
          this.openSnackBar('Oops! ' + error);
        }
      );
  }

  onSubmitConfirmation() {
    this.clickDouble = true;

    const sdate = new Date(this.f_date.value);
    const fDate = new Date(this.end_date_control.value);
    sdate.setHours(parseInt(this.f_turno.slice(0, 2)));
    sdate.setMinutes(parseInt(this.f_turno.slice(3, 5)));
    fDate.setHours(parseInt(this.f_turno.slice(0, 2)));
    fDate.setMinutes(parseInt(this.f_turno.slice(3, 5)));
    
    this.reserva.start_time = sdate;  
    this.reserva.end_date = fDate;
    
    this.reserva.facility = this.session.currentFacility.id;
    this.reserva.selected_weekdays = this.selected_weekdays;
  
    setTimeout(() => { this.clickDouble = false }, 3000)
  
    const reservaObservable = this.updateReserva
      ? this.reservasService.updateReservaRecurrente(this.reserva)
      : this.reservasService.addRecurrente(this.reserva);
  
    reservaObservable.subscribe(
      data => {
        this.openSnackBar("Reserva actualizada!");
        this.reservasService.notificarRecargaModReservas();
        this.modalRef.close(this.f_date.value);
      },
      (error) => {
        this.openSnackBar('Oops! El turno solicitado ya no está disponible. Por favor intente nuevamente.');
        console.log(error);
      }
    );
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, "", {
      duration: 2000
    });
  }

  setMinEndDate() {
    this.end_date_control.setValue(this.f_date.value);
  }

  formatDate(dateString: string): string {
    const date = moment(dateString);
    const formattedDate = date.format('dddd D [de] MMMM').toUpperCase();
    return this.capitalizeWords(formattedDate);
  }

  capitalizeWords(inputString: string): string {
    return inputString
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  selectTurno(){
    const endTime = new Date(this.reserva.end_time).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });

    const selectedShift = this.openShifts.find(shift => {
      const firstHour =  shift.split(' - ')[1];
      return endTime === firstHour;
    });

    this.f_turno = selectedShift;
  }
  
}

export interface WeekdayData {
  weekday: number[];
  start_date: Date;
  end_date: Date;
}